module.exports = __webpack_public_path__ + "heartFalse.5666e326.png";